import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LoadingState = {
  loading: boolean;
  setLoading: (type: boolean) => void;
};

const useLoadingStore = create(
  persist<LoadingState>(
    set =>
      ({
        loading: false,
        setLoading: (type: boolean) => set({ loading: type }),
      } as LoadingState),
    {
      name: '@tenGovUseLoadingStore',
    },
  ),
);

export default useLoadingStore;
